import type { ReactNode } from 'react'
import type { FocusEvent } from 'react'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next'
import { useFormContext } from 'react-hook-form'
import { twJoin } from 'tailwind-merge'
import FormInputRhf from 'shared/components/form-input-rhf'

interface AddPostInputFieldProps {
  name: string
  label: string
  maxLength?: number
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void
}

export default function AddPostInputField(props: AddPostInputFieldProps): ReactNode {
  const { control, setValue, watch, formState } = useFormContext()
  const { t } = useTranslation()
  const error = formState.errors[props.name]?.message as ParseKeys

  return (
    <div className="mb-6">
      <div className="relative font-medium">
        <FormInputRhf
          name={props.name}
          setValue={setValue}
          control={control}
          maxLength={props.maxLength}
          label={props.label}
          onFocus={props.onFocus}
          labelClassName="text-base"
          className="gap-0"
          inputClassName={twJoin(
            props.maxLength !== undefined && 'pr-18',
            error && 'border-danger',
          )}
        />
        {props.maxLength !== undefined && (
          <span className="absolute right-2 bottom-3 text-sm text-text-primary/50">
            {watch(props.name).length} / {props.maxLength}
          </span>
        )}
      </div>
      {error && <p className="mt-2 text-sm text-danger">{t(error)}</p>}
    </div>
  )
}
